import {
  GET_CONTACTS_START,
  GET_CONTACTS_SUCCESS,
  GET_CONTACTS_FAILED,
  BLOCK_CONTACTS_START,
  BLOCK_CONTACTS_FAIL,
  BLOCK_CONTACTS_SUCCESS,
  DELETE_CONTACTS_START,
  DELETE_CONTACTS_SUCCESS,
  DELETE_CONTACTS_FAIL,
  SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE,
  EMPTY_CONTACTS_LIST,
  NEW_CONTACTS_SUCCESS,
} from "./constants";

const getContactsStart = () => {
  return {
    type: GET_CONTACTS_START,
  };
};

const getContactsSuccess = (contacts) => {
  return {
    type: GET_CONTACTS_SUCCESS,
    payload: contacts,
  };
};

const getContactsFailed = (err) => {
  return {
    type: GET_CONTACTS_FAILED,
    error: {
      type: GET_CONTACTS_FAILED,
      message: err,
    },
  };
};

const blockContactsStartAction = (value) => ({
  type: BLOCK_CONTACTS_START,
  value,
});

const blockContactsSuccessAction = () => ({
  type: BLOCK_CONTACTS_SUCCESS,
});

const blockContactsFailAction = () => ({
  type: BLOCK_CONTACTS_FAIL,
});

const deleteContactsStartAction = (value) => ({
  type: DELETE_CONTACTS_START,
  value,
});

const deleteContactsSuccessAction = () => ({
  type: DELETE_CONTACTS_SUCCESS,
});

const deleteContactsFailAction = () => ({
  type: DELETE_CONTACTS_FAIL,
});

const newContactsSuccessAction = (contacts) => ({
  type: NEW_CONTACTS_SUCCESS,
  payload: contacts,
});

const showCustomerDetailsInContactsPage = (showCustomerDetailsInContactPage) => ({
  type: SHOW_CUSTOMER_DETAILS_IN_CONTACTS_PAGE,
  showCustomerDetailsInContactPage,
});

const emptyContactsList = () => ({
  type: EMPTY_CONTACTS_LIST,
});

export {
  getContactsStart,
  getContactsSuccess,
  getContactsFailed,
  blockContactsStartAction,
  blockContactsSuccessAction,
  blockContactsFailAction,
  deleteContactsStartAction,
  deleteContactsSuccessAction,
  deleteContactsFailAction,
  showCustomerDetailsInContactsPage,
  emptyContactsList,
  newContactsSuccessAction,
};
